module.exports = __webpack_public_path__ + "static/media/wish-card-entry.da3b9184.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/activity/couponspa/wish-card-entry.png
// module id = 1922
// module chunks = 6